import { render, staticRenderFns } from "./WorkPermitDay.vue?vue&type=template&id=6c6fff1d&scoped=true"
import script from "./WorkPermitDay.vue?vue&type=script&lang=js"
export * from "./WorkPermitDay.vue?vue&type=script&lang=js"
import style0 from "./WorkPermitDay.vue?vue&type=style&index=0&id=6c6fff1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fff1d",
  null
  
)

export default component.exports